import { AccountInterface, PaymentMode } from "../interfaces";

/**
 * Builds the list of authorizing accounts whose credit lines may be offered
 * in the payment mode selector.
 *
 * The consignee's credit lines must never be offered as a payment mode.
 * COD and DEST_BOXOFFICE_CREDIT set the draft's accountBillTo to the
 * consignee, and after a consignee swap accountBillTo can still point to the
 * previous consignee, so both the identity and the payment mode are checked:
 * either signal alone leaves a leak (identity misses the stale-consignee
 * sequence, payment mode misses the locker flow that bills the consignee
 * under CREDIT).
 */
export const getPaymentModeAuthAccounts = (
  shipper?: AccountInterface,
  accountBillTo?: AccountInterface,
  consignee?: AccountInterface,
  paymentMode?: PaymentMode
): AccountInterface[] => {
  const billToIsConsignee =
    !!accountBillTo?.id && accountBillTo.id === consignee?.id;
  const billToPaysAtDestination =
    paymentMode === PaymentMode.COD ||
    paymentMode === PaymentMode.DEST_BOXOFFICE_CREDIT;
  const includeBillToAccounts = !billToIsConsignee && !billToPaysAtDestination;

  return (shipper?.listAuthorizingAccount ?? []).concat(
    includeBillToAccounts ? accountBillTo?.listAuthorizingAccount ?? [] : []
  );
};
